/* eslint-disable no-restricted-syntax */

import type {
  DivisionLabel,
  SearchWalletProviderInterface,
  WalletId,
} from "@totalenergiescode/mobility-business-rev-form-data/components";
import type { GraphQLClient } from "graphql-request";

import { GetSupportsAndDivisionsQuery } from "./queries";

export class SearchWalletProvider implements SearchWalletProviderInterface {
  constructor(private graphqlClient: GraphQLClient) {}

  async search(accountId: string): Promise<Map<WalletId, DivisionLabel>> {
    const headers: Record<string, string> = {};
    headers["X-ACCOUNT-ID"] = accountId;

    const result = await this.graphqlClient.request(
      GetSupportsAndDivisionsQuery,
      {},
      headers,
    );

    const supports = result.LedgersMsGetSupportsAndDivisions?.supportAccounts;
    const walletsByDivision = new Map<WalletId, DivisionLabel>();

    if (!supports) return walletsByDivision;

    for (const supportAccount of supports) {
      if (supportAccount.divisionAccounts?.length) {
        for (const divisionAccount of supportAccount.divisionAccounts) {
          walletsByDivision.set(
            divisionAccount.walletId,
            divisionAccount.label,
          );
        }
      } else {
        walletsByDivision.set(supportAccount.walletId, supportAccount.label);
      }
    }

    return walletsByDivision;
  }
}
